import { render, staticRenderFns } from "./GroupParamsMobilePage.vue?vue&type=template&id=3c650215&scoped=true&"
import script from "./GroupParamsMobilePage.vue?vue&type=script&lang=js&"
export * from "./GroupParamsMobilePage.vue?vue&type=script&lang=js&"
import style0 from "./GroupParamsMobilePage.vue?vue&type=style&index=0&id=3c650215&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c650215",
  null
  
)

export default component.exports